var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pub-home" }, [
    _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "main-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.notice.title))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "main-body" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.notice.content) } })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btns" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              nativeOn: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close.apply(null, arguments)
                }
              }
            },
            [_vm._v("\n        确认\n      ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92eeb49c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92eeb49c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/components/PubInfo.vue
// module id = null
// module chunks = 